import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { ApiHttpService } from '../core/service/api-http.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-kiosk-page',
  templateUrl: './kiosk-page.component.html',
  styleUrls: ['./kiosk-page.component.scss'],
})
export class KioskPageComponent implements OnInit {
  BillResponse: any = {};
  id: string = '';
  step = 1;
  amount: number = 0;
  Sites: any[] = [];
  Codes: any = '';
  States: State[] = [];
  url: string = 'https://staging.engine.parking.ldcs.ae/';
  showPayButton: boolean = false;
  disabled: boolean = true;
  siteName: string = '';
  tenantId: string = '';
  onExit: boolean = false;
  provider: string = 'stripe'; // Default provider
  dataSend: ResponceData = {
    arrival: '',
    activityId: '',
    userId: null,
    plate: '',
    state: '',
    site: ''
  };
  public form: FormGroup = new FormGroup({
    state: new FormControl('', { validators: Validators.required }),
    site: new FormControl('', { validators: Validators.required }),
    plate: new FormControl('', { validators: Validators.required }),
  });
  selectedLang: string = 'en';
  translations: any = {
    en: {
      carInfoTitle: 'Car Information Lookup',
      selectState: 'Select State',
      selectStatePlaceholder: 'Select a state',
      stateRequired: 'Please select a state',
      plateText: 'Plate Text',
      plateTextPlaceholder: 'Plate Text',
      plateRequired: 'Plate Text is required',
      confirm: 'Confirm',
      formDesc: 'Use this form to get car information and payment details for the entered plate.',
      amount: 'Amount',
      paymentSuccess: 'Payment Completed Successfully',
      billZero: 'Your bill is 0.00 AED. Thank you for using Limitless Parking Ticketless System.',
      openBills: 'Open Bills',
      status: 'Status',
      exitTime: 'Exit Time',
      entryTime: 'Entry Time',
      backToSearch: 'Back to Search',
      plate: 'Plate Number',
      state: 'State',
      site: 'Site',
      noBillsMessage: 'No payment required. You have no outstanding bills at this location.',
      paymentMethods: 'Payment Methods',
      selectPaymentMethod: 'Select a payment method',
      totalAmount: 'Total Amount',
      currency: 'AED',
      proceedToPayment: 'Proceed to Payment',
      processing: 'Processing, please wait...',
      serviceCharge: 'service charge',
      includes: 'includes'
    },
    ar: {
      carInfoTitle: 'البحث عن معلومات السيارة',
      selectState: 'اختر الإمارة',
      selectStatePlaceholder: 'اختر الإمارة',
      stateRequired: 'يرجى اختيار الإمارة',
      plateText: 'رقم اللوحة',
      plateTextPlaceholder: 'رقم اللوحة',
      plateRequired: 'رقم اللوحة مطلوب',
      confirm: 'تأكيد',
      formDesc: 'استخدم هذا النموذج للحصول على معلومات السيارة وتفاصيل الدفع للوحة المدخلة.',
      amount: 'المبلغ',
      paymentSuccess: 'تم الدفع بنجاح',
      billZero: 'فاتورتك 0.00 درهم. شكرًا لاستخدامك نظام مواقف Limitless.',
      openBills: 'الفواتير المفتوحة',
      status: 'الحالة',
      exitTime: 'وقت الخروج',
      entryTime: 'وقت الدخول',
      backToSearch: 'العودة إلى البحث',
      plate: 'رقم اللوحة',
      state: 'الإمارة',
      site: 'الموقع',
      noBillsMessage: 'لا توجد مدفوعات مطلوبة. ليس لديك فواتير مستحقة في هذا الموقع.',
      paymentMethods: 'طرق الدفع',
      selectPaymentMethod: 'اختر طريقة الدفع',
      totalAmount: 'المبلغ الإجمالي',
      currency: 'درهم',
      proceedToPayment: 'المتابعة للدفع',
      processing: 'جاري المعالجة، يرجى الانتظار...',
      serviceCharge: 'رسوم الخدمة',
      includes: 'يتضمن'
    }
  };
  showLangDropdown: boolean = false;
  dropdownPosition: { top: string; left: string; right?: string } = { top: '60px', left: '24px' };
  billsData: any[] = [];

  // Test data for table display
  readonly TEST_BILLS_DATA = [
    {
      "arrival": "2024-05-21T12:04:48.421Z",
      "departureAttempt": "2024-05-21T16:06:52.425Z",
      "activityId": "664cdc3321f835cc9355f463",
      "userId": "null",
      "plate": "E15165",
      "state": "Dubai",
      "site": "Tilal Al Ghaf - Retail Hub",
      "siteCode": "5HQiui_M4RsI",
      "nested": [{ "areaType": "RESERVED", "timeSpent": 0 }, { "areaType": "PUBLIC", "timeSpent": 0 }, { "areaType": "VIP", "timeSpent": 0 }, { "areaType": "GYM", "timeSpent": 0 }]
    },
    {
      "arrival": "2024-05-22T09:30:00.000Z",
      "departureAttempt": "2024-05-22T14:15:30.000Z",
      "activityId": "664cdc3321f835cc9355f464",
      "userId": "null",
      "plate": "G78901",
      "state": "Abu Dhabi",
      "site": "Tilal Al Ghaf - Main Center",
      "siteCode": "5HQiui_M4RsI",
      "nested": [{ "areaType": "PUBLIC", "timeSpent": 0 }]
    },
    {
      "arrival": "2024-05-23T10:45:00.000Z",
      "departureAttempt": "2024-05-23T16:30:00.000Z",
      "activityId": "664cdc3321f835cc9355f465",
      "userId": "null",
      "plate": "S24680",
      "state": "Sharjah",
      "site": "Tilal Al Ghaf - North Gate",
      "siteCode": "5HQiui_M4RsI",
      "nested": [{ "areaType": "VIP", "timeSpent": 0 }]
    }
  ];

  // Add a flag to toggle test mode
  testMode: boolean = false;

  // Properties for payment methods
  paymentMethods: any[] = [];
  ids='';
  selectedPaymentMethod: any = null;
  isLoadingPaymentMethods: boolean = false;
  isProcessingPayment: boolean = false;

  // Add a property to show current environment
  currentEnvironment: string = 'PROD';

  t(key: string): string {
    return this.translations[this.selectedLang][key] || key;
  }

  toggleLangDropdown() {
    if (!this.showLangDropdown) {
      const langButton = document.querySelector('.lang-button') as HTMLElement;
      if (langButton) {
        const rect = langButton.getBoundingClientRect();
        // Set a fixed position for mobile screens
        if (window.innerWidth <= 480) {
          // For mobile, position dropdown in the center top of the screen
          this.dropdownPosition = {
            top: '70px',
            left: '50%',
            right: 'auto'
          };
          
          // Use CSS transform to center it
          setTimeout(() => {
            const dropdown = document.querySelector('.lang-dropdown') as HTMLElement;
            if (dropdown) {
              dropdown.style.transform = 'translateX(-50%)';
            }
          }, 0);
        } else {
          // For larger screens, position near the button
          this.dropdownPosition = {
            top: (rect.bottom + 5) + 'px',
            left: (this.selectedLang === 'ar' ? 'auto' : rect.left) + 'px',
            right: (this.selectedLang === 'ar' ? window.innerWidth - rect.right : 'auto') + 'px'
          };
        }
      }
    }
    this.showLangDropdown = !this.showLangDropdown;
  }

  changeLang(lang: string) {
    this.selectedLang = lang;
    document.body.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr'; // Also set on html element for CSS selectors
    document.documentElement.lang = lang; // Set language attribute
    this.showLangDropdown = false;
  }

  constructor(private api: ApiHttpService, private _formBuilder: FormBuilder, private router: ActivatedRoute) {
    // No need to re-initialize the form here as it's already defined as a class property
  }
  ngOnInit(): void {
    // Initialize language direction
    document.body.dir = this.selectedLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = this.selectedLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = this.selectedLang;
    
    // Get the current environment
    this.currentEnvironment = this.api.getCurrentEnvironment();
    
    // First check for URL parameters
    this.router.queryParams.subscribe((params: any) => {
      console.log('Kiosk Page Query Params:', params);
      
      // Handle tenantId
      if (params.tenantId) {
        this.tenantId = params.tenantId;
        // Update ApiHttpService for compatibility
        ApiHttpService.Xtenent = params.tenantId;
      } else {
        this.tenantId = ApiHttpService.Xtenent;
      }
      
      // Handle siteName
      if (params.siteName) {
        this.siteName = params.siteName;
        // Update form value
        this.form.controls['site'].setValue(this.siteName);
        // Update ApiHttpService for compatibility
        ApiHttpService.siteName = params.siteName;
      } else {
        this.siteName = ApiHttpService.siteName;
        this.form.controls['site'].setValue(this.siteName);
      }
      
      // Handle onExit
      if (params.onExit !== undefined) {
        this.onExit = params.onExit === 'true' || params.onExit === true;
        // Update ApiHttpService for compatibility
        ApiHttpService.onExit = this.onExit;
      } else {
        this.onExit = ApiHttpService.onExit;
      }
      
      // Handle provider
      if (params.provider !== undefined) {
        this.provider = params.provider;
      }
      
      // Log for debugging
      console.log('Kiosk Page Settings:', {
        siteName: this.siteName,
        tenantId: this.tenantId,
        onExit: this.onExit,
        provider: this.provider
      });
    });
    
    // Ensure the form has the site value set
    if (this.siteName) {
      this.form.controls['site'].setValue(this.siteName);
    }
    
    this.getStates();

    // Initialize with test data if in test mode
    if (this.testMode) {
      this.billsData = [...this.TEST_BILLS_DATA];
    }

    // Still listen for updates from the service for compatibility
    this.api.getObservable().subscribe((data: any) => {
      if (data.site) {
        this.Sites = [];
        this.Sites.push(data.site);
        this.siteName = data.site;
        this.form.controls['site'].setValue(data.site);
      }
    });

    // Add value changes listener to transform plate to uppercase
    this.form.get('plate')?.valueChanges.subscribe((value: string) => {
      if (value) {
        const upperValue = value.toUpperCase();
        if (upperValue !== value) {
          this.form.get('plate')?.setValue(upperValue, { emitEvent: false });
        }
      }
    });
  }

  onSubmit() {
    this.showPayButton = true;
    let data = {
      plate: this.form.value.plate,
      state: this.form.value.state,
      site: this.siteName,
    };

    // If in test mode, always use our test data and fetch payment methods
    if (this.testMode) {
      console.log('Test mode active - Using sample data regardless of API response');
      this.billsData = [...this.TEST_BILLS_DATA];
      this.step = 5;
      // In test mode, also fetch payment methods - but without payload
      let billsPayload = this.TEST_BILLS_DATA.map((bill: any) => ({
        "tenantId": this.tenantId || ApiHttpService.Xtenent,
        "arrival": bill.arrival,
        "departureAttempt": bill.departureAttempt,
        "plate": bill.plate,
        "state": bill.state,
        "site": bill.siteCode,
        "userId": bill.userId,
        "activityId": bill.activityId,
        "type": 0,
        "method": this.onExit ? "LINKONEXIT" : "LINK",
        "nested": bill?.nested || []
      }));
      this.fetchPaymentMethods(billsPayload);
      return;
    }

    this.api
      .postRequest(data.plate, data.state, this.siteName, this.onExit)
      .subscribe(
        (res: any) => {
          console.log('API Response:', res);

          if (res.status === 200 || res.status === undefined) {
            // Process the response data
            let responseData = res.body ? res.body.data : res.data;

            console.log('Response data:', responseData);

            // Always go to the bills table step
            this.step = 5;

            // Extract bills data and check if whitelisted
            const isWhitelisted = responseData && responseData.isWhitelisted;
            const bills = responseData && responseData.bills;
            const billsArray = Array.isArray(bills) ? bills : (bills ? [bills] : []);

            // Check if whitelisted - always show empty message
            if (isWhitelisted) {
              // User is whitelisted, show empty message regardless of bills
              this.billsData = [];
              // Customize message for whitelisted users
              this.setWhitelistedMessage();
            }
            // Check if we have bills in the response and user is NOT whitelisted
            else if (billsArray.length > 0) {
              // Prepare billing data for payment methods
              const billsPayload = billsArray.map((element: any) => {
                return {
                  "tenantId": this.tenantId || ApiHttpService.Xtenent,
                  "arrival": element.arrival,
                  "departureAttempt": element.departureAttempt,
                  "plate": element.plate,
                  "state": element.state,
                  "site": element.siteCode,
                  "userId": element.userId,
                  "activityId": element.activityId,
                  "type": 0,
                  "method": this.onExit ? "LINKONEXIT" : "LINK",
                  "nested": element?.nested || []
                };
              });

              // Handle both array and object formats
              this.billsData = this.processBillsData(billsArray);
              console.log('Processed bills data:', this.billsData);
              console.log('Bills payload for payment:', billsPayload);

              // Get payment methods if we have bills, passing the bills payload
              this.fetchPaymentMethods(billsPayload);
            } else {
              // Empty bills array - reset billsData
              this.billsData = [];
            }
          }
        },
        error => {
          console.error('API error:', error);
          // Still show bills table with empty data on error
          this.billsData = [];
          this.step = 5;
        });
  }

  // Helper method to set custom message for whitelisted users
  setWhitelistedMessage() {
    // We can customize the message if needed
    this.translations.en.noBillsMessage = 'You are on our Whitelist. No payment is required for your vehicle at this location.';
    this.translations.ar.noBillsMessage = 'أنت على القائمة البيضاء. لا توجد مدفوعات مطلوبة لمركبتك في هذا الموقع.';
  }

  processBillsData(bills: any[]) {
    // Ensure bills is an array, even if we get a single object
    const billsArray = Array.isArray(bills) ? bills : [bills];

    return billsArray.map(bill => {
      // Format dates
      const arrivalDate = bill.arrival ? new Date(bill.arrival) : null;
      const departureDate = bill.departureAttempt ? new Date(bill.departureAttempt) : null;

      const formatDate = (date: Date) => {
        if (isNaN(date.getTime())) return 'N/A'; // Handle invalid dates

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      };

      // Since we don't have amount or status in the API response,
      // we set default values for display purposes
      return { 
        exitTime: departureDate ? formatDate(departureDate) : '',
        entryTime: arrivalDate ? formatDate(arrivalDate) : '',
        // Store original data for reference if needed
        plateNumber: this.form.value.plate,
        state: bill.state,
        site: bill.site
      };
    });
  }

  backTo1() {
    this.step = 1;
  }

  getStates() {
    this.api.getStates().subscribe((res: any) => {
      this.States = res?.body?.data?.states || [];
    });
  }
  ngOnChanges(): void {
    if (this.form.value.state) {
      let name = this.form.value.state;
      let states = this.States.slice();
      let currentState = states.find(
        (ele) => ele.stateName == name
      )?.plateCodes;
      this.Codes = currentState;
      console.log(currentState);
    }
  }
  selectState() {
    console.log(this.form.value.state);
    if (this.form.value.state) {
      this.form.patchValue({
        code: '',
        number: '',
      });
      this.disabled = false;
      let name = this.form.value.state;
      let states = this.States.slice();
      let currentState = states.find(
        (ele) => ele.stateName == name
      )?.plateCodes;
      this.Codes = currentState;
      console.log(currentState);
    }
  }

  // Add a computed property for processed bills data
  get processedBillsData() {
    return this.billsData.map(bill => {
      const arrivalDate = new Date(bill.arrival);
      // Check if departureAttempt is null before creating Date object
      const departureDate = bill.departureAttempt ? new Date(bill.departureAttempt) : null;

      const formatDate = (date: Date | null) => {
        if (!date || isNaN(date.getTime())) return 'N/A';

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      };

      return {
        // Access the plate directly from the bill data
        plate: bill.plate || 'N/A',
        state: bill.state || 'N/A',
        site: bill.site || 'N/A',
        entryTime: isNaN(arrivalDate.getTime()) ? 'N/A' : formatDate(arrivalDate),
        exitTime: departureDate ? formatDate(departureDate) : 'N/A'
      };
    });
  }

  // Method to fetch payment methods
  fetchPaymentMethods(billsPayload?: any[]) {
    // Check if billsPayload is empty or null
    if (!billsPayload || billsPayload.length === 0) {
      console.log('No bills payload provided, showing empty message');
      this.billsData = [];
      return;
    }
    
    // Set loading state
    this.isLoadingPaymentMethods = true;
    
    // Log the request payload for debugging
    if (billsPayload) {
      console.log('Requesting payment with payload:', billsPayload);
    } else {
      console.log('Requesting payment without payload');
    }

    // Determine which payment API to use based on provider
    switch (this.provider.toLowerCase()) {
      case 'myfatoorah':
        // Use MyFatoorah payment gateway
        this.api.getPaymentMethods(billsPayload).subscribe(
          (res: any) => {
            this.isLoadingPaymentMethods = false;
            console.log('Payment methods response:', res);
            
            // If the response contains empty data or no ids, show empty message
            if (!res || !res.data || !res.data.IsSuccess || !res.data.Data || !res.data.Data.PaymentMethods || !res.ids) {
              console.warn('Empty payment methods response or missing ids');
              this.billsData = [];
              return;
            }
            
            if (res.data && res.data.IsSuccess && res.data.Data && res.data.Data.PaymentMethods) {
              this.paymentMethods = res.data.Data.PaymentMethods;
              this.ids = res.ids;
            } else {
              console.warn('Invalid or empty payment methods response, using defaults');
              this.setDefaultPaymentMethods();
              
              // Show notification if appropriate
              if (res && !res.IsSuccess) {
                this.api.showSnackbarCssStyles(
                  'Could not load payment methods. Using defaults.',
                  'OK',
                  { duration: 3000 }
                );
              }
            }
          },
          error => {
            this.isLoadingPaymentMethods = false;
            console.error('Payment methods error:', error);
            this.setDefaultPaymentMethods();
            this.billsData = []; // Show empty message on error
            
            // Show error notification
            this.api.showSnackbarCssStyles(
              'Failed to load payment methods. Using defaults.',
              'OK',
              { duration: 3000 }
            );
          }
        );
        break;

      case 'knet':
        // KNET payment processing
        if (billsPayload && billsPayload.length > 0) {
          // First get the amount for the plate
          const plateData = {
            licensePlate: this.form.value.plate
          };
          
          this.api.knetGetAmount(plateData).subscribe(
            (amountRes: any) => {
              console.log('KNET amount response:', amountRes);
              
              if (amountRes && amountRes.data && amountRes.data.amount) {
                // If we have the amount, proceed with payment
                const paymentData = {
                  amount: amountRes.data.amount
                };
                
                this.api.knetPay(paymentData).subscribe(
                  (payRes: any) => {
                    this.isLoadingPaymentMethods = false;
                    console.log('KNET payment response:', payRes);
                    
                    if (payRes && payRes.data && payRes.data.url) {
                      // Redirect to KNET payment URL
                      window.location.href = payRes.data.url;
                    } else {
                      this.api.showSnackbarCssStyles(
                        'Failed to initiate KNET payment. Please try again.',
                        'OK',
                        { duration: 5000 }
                      );
                    }
                  },
                  error => {
                    this.isLoadingPaymentMethods = false;
                    console.error('KNET payment error:', error);
                    this.api.showSnackbarCssStyles(
                      'Failed to initiate KNET payment. Please try again.',
                      'OK',
                      { duration: 5000 }
                    );
                  }
                );
              } else {
                this.isLoadingPaymentMethods = false;
                this.api.showSnackbarCssStyles(
                  'Could not get payment amount. Please try again.',
                  'OK',
                  { duration: 5000 }
                );
              }
            },
            error => {
              this.isLoadingPaymentMethods = false;
              console.error('KNET amount error:', error);
              this.api.showSnackbarCssStyles(
                'Failed to get payment amount. Please try again.',
                'OK',
                { duration: 5000 }
              );
            }
          );
        } else {
          this.isLoadingPaymentMethods = false;
          this.billsData = []; // Show empty message when no billsPayload
          this.api.showSnackbarCssStyles(
            'No bills data available for payment.',
            'OK',
            { duration: 3000 }
          );
        }
        break;

      case 'paytabs':
        // Use PayTabs payment gateway
        if (billsPayload && billsPayload.length > 0) {
          this.api.paytabsPay(billsPayload).subscribe(
            (res: any) => {
              this.isLoadingPaymentMethods = false;
              console.log('PayTabs API response:', res);
              
              // If the response has no URL, show empty message
              if (!res || !res.data || !res.data.url) {
                console.warn('No payment URL in response');
                this.billsData = [];
                return;
              }
              
              if (res.data && res.data.url) {
                // Redirect to payment URL immediately
                window.location.href = res.data.url;
              } else {
                // Show error message
                this.api.showSnackbarCssStyles(
                  'Payment initiation failed. Please try again.',
                  'OK',
                  { duration: 5000 }
                );
              }
            },
            error => {
              this.isLoadingPaymentMethods = false;
              console.error('PayTabs API error:', error);
              this.billsData = []; // Show empty message on error
              this.api.showSnackbarCssStyles(
                'Payment initiation failed. Please try again.',
                'OK',
                { duration: 5000 }
              );
            }
          );
        } else {
          this.isLoadingPaymentMethods = false;
          this.billsData = []; // Show empty message when no billsPayload
          this.api.showSnackbarCssStyles(
            'No bills data available for payment.',
            'OK',
            { duration: 3000 }
          );
        }
        break;

      case 'ni':
        if (billsPayload && billsPayload.length > 0) {
          this.api.niPay(billsPayload).subscribe(
            (res: any) => {
              this.isLoadingPaymentMethods = false;
              console.log('NI payment response:', res);

              if (!res || !res.data || !res.data.url) {
                console.warn('No payment URL in response');
                this.billsData = [];
                return;
              }

              if (res.data && res.data.url) {
                window.location.href = res.data.url;
              } else {
                this.api.showSnackbarCssStyles(
                  'Payment initiation failed. Please try again.',
                  'OK',
                  { duration: 5000 }
                );
              }
            },
            error => {
              this.isLoadingPaymentMethods = false;
              console.error('NI payment error:', error);
              this.billsData = [];
              this.api.showSnackbarCssStyles(
                'Payment initiation failed. Please try again.',
                'OK',
                { duration: 5000 }
              );
            }
          );
        } else {
          this.isLoadingPaymentMethods = false;
          this.billsData = [];
          this.api.showSnackbarCssStyles(
            'No bills data available for payment.',
            'OK',
            { duration: 3000 }
          );
        }
        break;

      case 'stripe':
      default:
        // Use the regular pay API
        if (billsPayload && billsPayload.length > 0) {
          this.api.pay(billsPayload).subscribe(
            (res: any) => {
              this.isLoadingPaymentMethods = false;
              console.log('Pay API response:', res);
              
              // If the response has no URL, show empty message
              if (!res || !res.data || !res.data.url) {
                console.warn('No payment URL in response');
                this.billsData = [];
                return;
              }
              
              if (res.data && res.data.url) {
                // Redirect to payment URL immediately
                window.location.href = res.data.url;
              } else {
                // Show error message
                this.api.showSnackbarCssStyles(
                  'Payment initiation failed. Please try again.',
                  'OK',
                  { duration: 5000 }
                );
              }
            },
            error => {
              this.isLoadingPaymentMethods = false;
              console.error('Pay API error:', error);
              this.billsData = []; // Show empty message on error
              this.api.showSnackbarCssStyles(
                'Payment initiation failed. Please try again.',
                'OK',
                { duration: 5000 }
              );
            }
          );
        } else {
          this.isLoadingPaymentMethods = false;
          this.billsData = []; // Show empty message when no billsPayload
          this.api.showSnackbarCssStyles(
            'No bills data available for payment.',
            'OK',
            { duration: 3000 }
          );
        }
        break;
    }
  }

  // Helper method to set default payment methods
  setDefaultPaymentMethods() {
    this.paymentMethods = [];
  }

  // Method to execute payment
  executePayment(paymentMethod: any) {
    if (!paymentMethod) return;

    this.selectedPaymentMethod = paymentMethod;
    this.isProcessingPayment = true;

    // Use the actual amount or 1 AED for testing

    // Default to AED if no currency specified
    const currency = paymentMethod.CurrencyIso || 'AED';

    this.api.executePayment(
      this.ids,
      paymentMethod.PaymentMethodId.toString(),
       paymentMethod.TotalAmount.toString(),
      currency
    ).subscribe(
      (res: any) => {
        console.log('Execute payment response:', res);
        if (res && res.url) {
          // Redirect to payment URL immediately
          window.location.href = res.url;
        } else {
          this.isProcessingPayment = false;
          // Show error message
          this.api.showSnackbarCssStyles(
            'Payment initiation failed. Please try again.',
            'OK',
            { duration: 5000 }
          );
        }
      },
      error => {
        this.isProcessingPayment = false;
        console.error('Execute payment error:', error);
        this.api.showSnackbarCssStyles(
          'Payment initiation failed. Please try again.',
          'OK',
          { duration: 5000 }
        );
      }
    );
  }

  // Add method to toggle environment
  toggleEnvironment() {
    this.api.toggleEnvironment();
    // Update the environment label
    this.currentEnvironment = this.api.getCurrentEnvironment();
  }
}
export interface Bill {
  publicId: string;
  publicBill: {
    publicId: string;
    amount: number;
  };
}
export interface State {
  stateName: string;
  plateCodes: string[];
}
export interface ResponceData {
  arrival: string;
  activityId: string;
  userId: string | null;
  plate: string;
  state: string;
  site: string;
}

export interface UrlData {
  tenantId: string,
  arrival: string,
  departureAttempt: string,
  plate: string,
  state: string,
  site: string,
  userId: string,
  activityId: string,
  type: number,
  method: string,
  nested: nested[]
}
interface nested {
  "areaType": string,
  "timeSpent": number
}
/*

        "arrival": "2024-05-21T12:04:48.421Z",
        "departureAttempt": "2024-05-21T16:06:52.425Z",
        "activityId": "664cdc3321f835cc9355f463",
        "userId": "null",
        "plate": "E15165",
        "state": "Dubai",
        "site": "Tilal Al Ghaf - Retail Hub",
        "siteCode":"5HQiui_M4RsI",
        "nested": [{"areaType": "RESERVED", "timeSpent": 0}, {"areaType": "PUBLIC", "timeSpent": 0}, {"areaType": "VIP", "timeSpent": 0}, {"areaType": "GYM", "timeSpent": 0}]


*/
